import { useState, useRef, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { deleteHoleScores, deleteEventEntry } from "../util/db";

function ConfirmDeletePlayerModal(props) {
  const [show, setShow] = useState(false);
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleClose = () => {
    if (isMountedRef.current) {
      setShow(false);
    }
  };

  const handleShow = () => {
    if (isMountedRef.current) {
      setShow(true);
    }
  };

  const handleConfirm = async () => {
    try {
      // Remove scorecard from db
      await deleteHoleScores(props.eventEntryId);

      // Remove event entry id from event entry table
      // The deleteEventEntry function will handle query invalidation
      await deleteEventEntry(
        props.eventEntryId,
        props.eventId,
        props.eventDivisionsId
      );

      // Don't explicitly close modal - component will unmount naturally
      // when parent re-renders after successful deletion
    } catch (error) {
      console.error("Error removing player:", error);
      // Only close modal on error to allow user to try again
      handleClose();
    }
  };

  return (
    <>
      <div style={{ cursor: "pointer" }} onClick={handleShow}>
        {props.buttonText}
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{props.heading ? props.heading : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.bodyText ? props.bodyText : "Are you sure?"}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {props.cancelText ? props.cancelText : "Cancel"}
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            {props.confirmText ? props.confirmText : "Confirm"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ConfirmDeletePlayerModal;
